<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<div class="ajuda">
  <div class="ajuda__header">
    <div class="header__duvida">
      <p class="duvida__titulo">Ficou com alguma dúvida?</p>
      <p class="duvida__subtitulo">A gente te ajuda</p>
    </div>
    <div class="header__filtro">
      <img class="filtro__icone" src="assets/images/icons/pesquisar.png" />
      <input class="filtro__input" type="text" placeholder="Digite sua dúvida..." [(ngModel)]="filtroFaq" />
    </div>
    <div class="header__background">
      <img class="background__imagem" src="assets/images/backgrounds/background_gradiente_baixo.png" />
    </div>
  </div>

  <div class="ajuda__faq">
    <p class="faq__titulo">{{ tituloFaq }}</p>
    <app-faq *ngIf="!carregandoFAQ" [faq]="faq" [verMais]="true" [filtro]="filtroFaq"></app-faq>
    <ngx-skeleton-loader *ngIf="carregandoFAQ" count="7" [theme]="{
        'border-radius': '2px',
        width: '100%',
        height: '48px',
        margin: '0 8px 0 0'
      }"></ngx-skeleton-loader>
    <ngx-skeleton-loader *ngIf="carregandoFAQ" count="1" [theme]="{
        'border-radius': '2px',
        width: '170px',
        height: '32px',
        margin: '24px 8px 0 0'
      }"></ngx-skeleton-loader>
  </div>

  <div class="ajuda__chamado" id="atendimento">
    <p class="chamado__titulo">Atendimento</p>
    <form class="chamado__form" novalidate [formGroup]="chamadoForm" (submit)="enviarChamado()">
      <div class="grid--2-1">
        <input class="chamado__input" type="text" placeholder="Nome completo" formControlName="nome" />
        <input class="chamado__input" type="text" placeholder="CPF" pattern="[0-9]*" inputmode="numeric"
          formControlName="cpf" mask="000.000.000-00" />
      </div>

      <div class="grid--2-1">
        <input class="chamado__input" type="text" placeholder="E-mail" formControlName="email" />

        <input class="chamado__input" type="text" pattern="[0-9]*" inputmode="numeric" placeholder="Telefone"
          formControlName="telefone" mask="(00) 00000-0000" />
      </div>

      <select class="chamado__input" id="tipo" formControlName="tipo">
        <option [value]="''" disabled selected>
          Sobre o que gostaria de falar?
        </option>
        <option *ngFor="let tipo of tiposChamado" [value]="tipo.chave">
          {{ tipo.valor }}
        </option>
      </select>
      <div class="select__message" *ngIf="chamadoForm.controls.tipo.touched">É importante que ao selecionar essa opção,
        ela
        seja a mais próxima possível ao
        conteúdo que você realmente precisa de ajuda, assim conseguiremos garantir que todos os casos sejam tratados de
        forma mais assertiva de acordo com o motivo.</div>

      <div class="grid--2-1" *ngIf="this.exigirInformacoesEcom(chamadoForm.value.tipo)">
        <input class="chamado__input" type="text" placeholder="Número do pedido" formControlName="numeroPedido" />
        <input class="chamado__input" type="text" placeholder="Data do Pedido" pattern="[0-9]*" inputmode="numeric"
          formControlName="dataPedido" mask="00/00/0000" />
      </div>

      <textarea class="chamado__input input--textarea" placeholder="Escreva aqui sua mensagem" name="" id="" cols="30"
        rows="10" formControlName="descricao"></textarea>

      <div class="form__anexos">
        <input id="chamado-anexos" name="chamado-anexos" type="file" [hidden]="true" formControlName="path"
          (change)="onAnexo($event)" />
        <span for="chamado-anexos" class="anexos__anexar" (click)="carregarAnexos()">
          <img class="anexar__icone" src="assets/images/icons/anexo.png" />
          Anexar Arquivo
        </span>
      </div>

      <div class="anexos">
        <div class="anexo" *ngFor="let anexo of chamadoForm.value.anexos; let i = index" (click)="removerAnexo(i)">
          <img class="anexo__remover" src="assets/images/icons/x.png" />
          <img class="anexo__imagem" [src]="anexo.src" />
          <p>{{ anexo.nome }}</p>
        </div>
      </div>

      <div class="form__termos">
        <div class="termos__termo">
          <input type="checkbox" id="termo-politica" formControlName="aceitePolitica" />
          <label for="termo-politica">Estou ciente e aceito os termos da política de privacidade da Cacau
            Show</label>
        </div>
        <div class="termos__termo">
          <input type="checkbox" id="termo-dados" formControlName="aceiteDados" />
          <label for="termo-dados">Estou ciente e aceito que os meus dados, fornecidos neste
            formulário, sejam utilizados apenas com a finalidade de me
            identificar e retornar o contato</label>
        </div>
      </div>

      <div class="form__buttons">
        <button type="submit" class="lovers-button" [disabled]="!chamadoForm.valid || enviandoChamado" [ngClass]="{
            'lovers--disabled': !chamadoForm.valid || enviandoChamado
          }">
          Enviar
          <i *ngIf="enviandoChamado" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
    </form>
  </div>

  <img class="background__imagem__footer" src="assets/images/backgrounds/background_gradiente_cima.png" />
</div>

<lovers-popup [exibir]="exibePopupGenerico" (onClose)="exibePopupGenerico = false" tamanho="grande">
  <div class="popup__header">
    <p class="header__title">{{ tituloPopupGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>
